/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Speaker_HeaderInputs */



/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Speakers_Metrics_Speaker_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_speaker_header = /** @type {((inputs?: Speakers_Metrics_Speaker_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Speaker_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "it") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "es") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Speakers")
	return /** @type {LocalizedString} */ ("Speakers")
});